import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class EncryptionDescriptionService {
  private publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArsYlhtsrLbgHS///uAuxxKOqlnd7jCbtDFrbO7L54XfjOfHmLoFa2CY8F0b7szrdbjCQ4YlYWMhYP1QOH36fRu/28OvceHs4MHYPE68LwwvqMxIByiHUib/TCbat04JHqQBsuPWyeryGsNVAVtbs4A9cUfBOnkSPKHs9NGtuWGXsMiG17mW6DvZ4S0MsfxLASKJDAS1xHvsHgfzmXbDUkOvbeJ6dQP4enqJ2yD9pLNb3ioPKqUKIk7GMgIgNP+9deIl3Eu3BYZvMww747/1AaWER+agPqAk36XJyMoO0FwUr2ccAJFfs/8FmscunfHdueOdN0glncdW0axyDrCa2TQIDAQAB";

  encryptWithPublicKey(message: string): string {
    // Decode the Base64 public key
    const publicKeyDer = forge.util.decode64(this.publicKey);

    // Convert the decoded DER to ASN.1
    const publicKeyAsn1 = forge.asn1.fromDer(publicKeyDer);

    // Get RSA Public Key
    const publicKey = forge.pki.publicKeyFromAsn1(publicKeyAsn1);

    // Encrypt the message with RSA-OAEP (commonly used and secure)
    const encryptedBytes = publicKey.encrypt(message, 'RSA-OAEP');

    // Encode encrypted data as Base64 for transfer
    return forge.util.encode64(encryptedBytes);
  }
  // decryptWithPrivateKey(encryptedMessage: string, privateKeyString: string): string {
  //   // Decode the Base64-encoded private key
  //   const privateKeyDer = forge.util.decode64(this.privateKey);

  //   // Convert to ASN.1 structure
  //   const privateKeyAsn1 = forge.asn1.fromDer(privateKeyDer);

  //   // Get RSA Private Key from ASN.1
  //   const privateKey = forge.pki.privateKeyFromAsn1(privateKeyAsn1);

  //   // Decode the Base64-encoded encrypted message
  //   const encryptedBytes = forge.util.decode64(encryptedMessage);

  //   // Decrypt with RSA-OAEP
  //   const decryptedBytes = privateKey.decrypt(encryptedBytes, 'RSA-OAEP');

  //   // Convert decrypted bytes to a UTF-8 string
  //   return decryptedBytes;
  // }

}